import React, { Component } from "react";
import PropTypes from "prop-types";
//import {Button} from '../button/Button';
import FSButton from "components/Button";
//import {Messages} from '../messages/Messages';
import { ProgressBar } from "react-bootstrap";
//import {ProgressBar} from '../progressbar/ProgressBar';
import DomHandler from "../../utils/DomHandler";
import classNames from "classnames";
import other from "assets/img/file_other.png";
import "./FileUpload.scss";

export class FileUpload extends Component {
  static defaultProps = {
    id: null,
    name: null,
    url: null,
    mode: "advanced",
    multiple: false,
    accept: null,
    disabled: false,
    auto: false,
    maxFileSize: null,
    invalidFileSizeMessageSummary: "{0}: Invalid file size, ",
    invalidFileSizeMessageDetail: "maximum upload size is {0}.",
    style: null,
    className: null,
    widthCredentials: false,
    previewWidth: 50,
    chooseLabel: "Choose",
    uploadLabel: "Upload",
    cancelLabel: "Cancel",
    onBeforeUpload: null,
    onBeforeSend: null,
    onUpload: null,
    onError: null,
    onClear: null,
    onSelect: null,
    onProgress: null,
    multiFiles: false,
    maxHeight: null,
    maxWidth: null,
    uploadMethod: "POST",
    defaultImageUrl: null,
    hiddenRemoveIcon: false,
    IsRemoveLogoButton: false,
  };

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    mode: PropTypes.string,
    multiple: PropTypes.bool,
    accept: PropTypes.string,
    disabled: PropTypes.bool,
    auto: PropTypes.bool,
    maxFileSize: PropTypes.number,
    invalidFileSizeMessageSummary: PropTypes.string,
    invalidFileSizeMessageDetail: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    widthCredentials: PropTypes.bool,
    previewWidth: PropTypes.number,
    chooseLabel: PropTypes.string,
    uploadLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    onBeforeUpload: PropTypes.func,
    onBeforeSend: PropTypes.func,
    onUpload: PropTypes.func,
    onError: PropTypes.func,
    onClear: PropTypes.func,
    onSelect: PropTypes.func,
    onRemoveFile: PropTypes.func,
    onProgress: PropTypes.func,
    headers: PropTypes.any,
    withCredentials: PropTypes.any,
    showIcon: PropTypes.bool,
    multiFiles: PropTypes.bool,
    maxHeight: PropTypes.number,
    maxWidth: PropTypes.number,
    uploadMethod: PropTypes.any,
    defaultImageUrl: PropTypes.string,
    hiddenRemoveIcon: PropTypes.bool,
    IsRemoveLogoButton: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      files: [],
      msgs: [],
      defaultImageUrl: this.props.defaultImageUrl,
    };

    this.upload = this.upload.bind(this);
    this.clear = this.clear.bind(this);
    this.onFileSelect = this.onFileSelect.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onSimpleUploaderClick = this.onSimpleUploaderClick.bind(this);
  }

  hasFiles() {
    return this.state.files && this.state.files.length > 0;
  }

  isImage(file) {
    return /^image\//.test(file.type);
  }

  remove(index) {
    this.clearInputElement();
    let currentFiles = [...this.state.files];
    currentFiles.splice(index, 1);
    this.setState({ files: currentFiles });
    if (this.props.onRemoveFile) {
      this.props.onRemoveFile();
    }
  }

  clearInputElement() {
    if (this.fileInput) {
      this.fileInput.value = "";

      if (this.props.mode === "basic") {
        this.fileInput.style.display = "inline";
      }
    }
  }

  formatSize(bytes) {
    if (bytes === 0) {
      return "0 B";
    }
    let k = 1000;
    let dm = 3;
    let sizes = ["B", "KB", "MB", "GB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  onFileSelect(event) {
    let errors = "";
    let typeError = false;
    const { onSelect, maxHeight, maxWidth } = this.props;
    this.files = this.state.files || [];
    let files = event.dataTransfer
      ? event.dataTransfer.files
      : event.target.files;

    for (let file of files) {
      if (!this.isFileSelected(file)) {
        if (this.isImage(file)) {
          const isAccepted = this.props.accept
            ? this.props.accept.indexOf(file.type)
            : 1;
          if (isAccepted !== -1) {
            file.objectURL = window.URL.createObjectURL(file);

            if (this.props.maxFileSize && file.size > this.props.maxFileSize) {
              /*this.messagesUI.show({
                severity: 'error',
                summary: this.props.invalidFileSizeMessageSummary.replace('{0}', file.name),
                detail: this.props.invalidFileSizeMessageDetail.replace('{0}', this.formatSize(this.props.maxFileSize))
              });*/
              errors = `File size must not exceed ${(
                this.props.maxFileSize / 1048576
              ).toFixed(0)} MB`;
              if (onSelect) {
                onSelect({ originalEvent: event, files: this.files, errors });
              }
            } else if (this.props.maxHeight && this.props.maxWidth) {
              const reader = new FileReader();
              //Read the contents of Image File.
              reader.readAsDataURL(file);
              /* eslint-disable */
              reader.onload = function (e) {
                //Initiate the JavaScript Image object.
                const image = new Image();

                //Set the Base64 string return from FileReader as source.
                image.src = e.target.result;

                //Validate the File Height and Width.
                image.onload = function () {
                  const height = this.height;
                  const width = this.width;
                  if (height > maxHeight || width > maxWidth) {
                    errors = "Frame size is 368x64 px";
                    if (onSelect) {
                      onSelect({
                        originalEvent: event,
                        files: this.files,
                        errors,
                      });
                    }
                  }
                };
              };
            }
          } else {
            errors = "Only PNG, JPG supported";
            file.objectURL = other;
            this.files = [file];
            onSelect({ originalEvent: event, files: this.files, errors });
          }
        } else {
          errors = "Only PNG, JPG supported";
          typeError = true;
          if (onSelect) {
            onSelect({ originalEvent: event, files: this.files, errors });
          }
        }
        if (this.props.multiFiles) {
          this.files.push(file);
          onSelect({ originalEvent: event, files: this.files, errors });
        } else {
          if (typeError) {
            file.objectURL = other;
          }
          this.files = [file];
          onSelect({ originalEvent: event, files: this.files, errors });
        }
      }
    }
    this.setState({ files: this.files }, () => {
      if (this.hasFiles() && this.props.auto && !errors) {
        this.upload();
      }
    });

    this.clearInputElement();

    if (this.props.mode === "basic") {
      this.fileInput.style.display = "none";
    }
  }

  isFileSelected(file) {
    for (let sFile of this.state.files) {
      if (
        sFile.name + sFile.type + sFile.size ===
        file.name + file.type + file.size
      ) {
        return true;
      }
    }
    return false;
  }

  upload() {
    this.setState({ msgs: [] });
    let xhr = new XMLHttpRequest();
    let formData = new FormData();

    if (this.props.onBeforeUpload) {
      this.props.onBeforeUpload({
        xhr: xhr,
        formData: formData,
      });
    }

    for (let file of this.state.files) {
      formData.append(this.props.name, file, file.name);
    }

    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        this.setState({
          progress: Math.round((event.loaded * 100) / event.total),
        });
      }

      if (this.props.onProgress) {
        this.props.onProgress({
          originalEvent: event,
          progress: this.progress,
        });
      }
    });

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        this.setState({ progress: 0 });

        if (xhr.status >= 200 && xhr.status < 300) {
          if (this.props.onUpload) {
            this.props.onUpload({ xhr: xhr, files: this.files });
          }
        } else {
          if (this.props.onError) {
            this.props.onError({ xhr: xhr, files: this.files });
          }
        }

        // Keep files to show remove button
        // this.clear();
      }
    };

    xhr.open(this.props.uploadMethod, this.props.url, true);

    if (this.props.headers) {
      for (let i = 0; i < this.props.headers.length; i++) {
        let header = this.props.headers[0];
        let key = Object.keys(header)[0];
        xhr.setRequestHeader(key, header[key]);
      }
    }

    if (this.props.onBeforeSend) {
      this.props.onBeforeSend({
        xhr: xhr,
        formData: formData,
      });
    }

    xhr.withCredentials = this.props.withCredentials;

    xhr.send(formData);
  }

  clear() {
    this.setState({ files: [] });
    if (this.props.onClear) {
      this.props.onClear();
    }
    this.clearInputElement();
  }

  onFocus(event) {
    DomHandler.addClass(event.currentTarget.parentElement, "ui-state-focus");
  }

  onBlur(event) {
    DomHandler.removeClass(event.currentTarget.parentElement, "ui-state-focus");
  }

  onDragEnter(event) {
    if (!this.props.disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onDragOver(event) {
    if (!this.props.disabled) {
      DomHandler.addClass(this.content, "ui-fileupload-highlight");
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onDragLeave() {
    if (!this.props.disabled) {
      DomHandler.removeClass(this.content, "ui-fileupload-highlight");
    }
  }

  onDrop(event) {
    if (!this.props.disabled) {
      DomHandler.removeClass(this.content, "ui-fileupload-highlight");
      event.stopPropagation();
      event.preventDefault();

      let files = event.dataTransfer
        ? event.dataTransfer.files
        : event.target.files;
      let allowDrop = this.props.multiple || (files && files.length === 1);

      if (allowDrop) {
        this.onFileSelect(event);
      }
    }
  }

  onSimpleUploaderClick() {
    if (this.hasFiles()) {
      this.upload();
    }
  }

  renderChooseButton() {
    let className = classNames(
      "ui-fileupload-choose ui-button ui-widget ui-state-default ui-corner-all"
    );

    return (
      <span icon="fa-plus" className={className}>
        <input
          ref={(el) => {
            this.fileInput = el;
          }}
          type="file"
          onChange={this.onFileSelect}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          multiple={this.props.multiple}
          accept={this.props.accept}
          disabled={this.props.disabled}
        />
        <span className="ui-button-icon ui-button-icon-left ui-clickable fa fa-fw fa-plus" />
        <span className="ui-button-text ui-clickable">
          {this.props.chooseLabel}
        </span>
      </span>
    );
  }

  renderFiles() {
    console.log(
      "🚀 ~ FileUpload ~ renderFiles ~ this.props.hiddenRemoveIcon:",
      this.props.hiddenRemoveIcon
    );
    return (
      <div className="ui-fileupload-files">
        {this.state.files.map((file, index) => {
          let preview = (
            <div className="img-review">
              <img
                alt={file.name}
                role="presentation"
                src={
                  this.state.files.length === 0
                    ? this.props.defaultImageUrl
                    : file.objectURL
                }
                width={this.props.previewWidth}
              />
            </div>
          );
          let fileName = <div className="file-name">{file.name}</div>;
          let size = (
            <div className="file-size">{this.formatSize(file.size)}</div>
          );
          let removeButton = (
            <div className="remove-file">
              <FSButton
                type="button"
                onClick={() => {
                  this.remove(index);
                  this.setState({ defaultImageUrl: null });
                }}
                className="btn"
              >
                <span className="fa fa-close" />
              </FSButton>
            </div>
          );

          return (
            <div
              className="ui-fileupload-row"
              key={file.name + file.type + file.size}
            >
              {preview}
              {fileName}
              {size}
              {!this.props.hiddenRemoveIcon && removeButton}
            </div>
          );
        })}
      </div>
    );
  }

  renderDefaultImagePreview() {
    let preview = (
      <div className="img-review">
        <img
          alt="siteone"
          role="presentation"
          src={this.state.defaultImageUrl}
          width={this.props.previewWidth}
        />
      </div>
    );

    return (
      <div className="ui-fileupload-files">
        <div className="ui-fileupload-row">{preview}</div>
      </div>
    );
  }

  renderAdvanced() {
    let className = classNames("ui-fileupload ui-widget", this.props.className);
    let uploadButton;
    let cancelButton;
    let filesList;
    let progressBar;
    let chooseButton = this.renderChooseButton();

    let removeLogoButton = (
      <button
        className="btn btn-danger"
        onClick={this.props.onRemoveFile}
        style={{
          flexShrink: 0,
          height: "38px",
          marginLeft: "10px",
        }}
      >
        Remove Logo
      </button>
    );

    if (!this.props.auto) {
      uploadButton = (
        <FSButton
          label={this.props.uploadLabel}
          className="btn btn-primary btn-siteone"
          icon="fa-upload"
          onClick={this.upload}
          disabled={this.props.disabled || !this.hasFiles()}
        />
      );
      cancelButton = (
        <FSButton
          label={this.props.cancelLabel}
          className="cancel-btn"
          icon="fa-close"
          onClick={this.clear}
          disabled={this.props.disabled || !this.hasFiles()}
        />
      );
    }

    if (this.hasFiles()) {
      filesList = this.renderFiles();
      progressBar = (
        <ProgressBar value={this.state.progress} showValue={false} />
      );
      className += " have-files";
    } else if (this.state.defaultImageUrl) {
      filesList = this.renderDefaultImagePreview();
    }

    //<Messages ref={(el) => {this.messagesUI = el; }} />
    return (
      <div id={this.props.id} className={className} style={this.props.style}>
        <div
          ref={(el) => {
            this.content = el;
          }}
          className="ui-fileupload-content ui-widget-content ui-corner-bottom"
          onDragEnter={this.onDragEnter}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          //onClick={() => {this.fileInput.click();}}
        >
          {progressBar}
          {filesList}
        </div>
        <div className="ui-fileupload-buttonbar ui-widget-header ui-corner-top">
          {chooseButton}
          {uploadButton}
          {cancelButton}
          {this.props.IsRemoveLogoButton && removeLogoButton}
        </div>
      </div>
    );
  }

  renderBasic() {
    let buttonClassName = classNames(
      "ui-button ui-fileupload-choose ui-widget ui-state-default ui-corner-all ui-button-text-icon-left",
      { "ui-fileupload-choose-selected": this.hasFiles() }
    );
    let iconClassName = classNames("ui-button-icon-left fa", {
      "fa-plus": !this.hasFiles() || this.props.auto,
      "fa-upload": this.hasFiles() && !this.props.auto,
    });

    let file;
    if (this.props.auto) {
      file = this.props.chooseLabel;
    } else {
      if (this.hasFiles()) {
        file = this.state.files[0].name;
      } else {
        file = this.props.chooseLabel;
      }
    }

    return (
      <span className={buttonClassName} onMouseUp={this.onSimpleUploaderClick}>
        {this.props.showIcon && <span className={iconClassName} />}
        <span className="ui-button-text ui-clickable">{file}</span>
        <input
          ref={(el) => {
            this.fileInput = el;
          }}
          type="file"
          multiple={this.props.multiple}
          accept={this.props.accept}
          disabled={this.props.disabled}
          onChange={this.onFileSelect}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
      </span>
    );
  }

  render() {
    if (this.props.mode === "advanced") {
      return this.renderAdvanced();
    }
    return this.renderBasic();
  }
}



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js